import Vue from 'vue'

export default {
  sendLoyaltyPoints(payload) {
    return Vue.http.post('loyalty/send-points', payload)
  }
}
